import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TopicsPage from "../pages/topics/page";
import TopicDetailPage from "../pages/topic-detail/page";
import RankPage from "../pages/rank/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topics",
    element: <TopicsPage />,
  },
  {
    path: "/topics/:id",
    element: <TopicDetailPage />,
  },
  {
    path: "/rank",
    element: <RankPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;